type OrdinalMediaPage = {
    page?: number
    has_more?: boolean
    items?: readonly unknown[]
}

export function resolveNextOrdinalMediaPage(
    lastPage: OrdinalMediaPage | null | undefined,
    loadedPageCount: number,
): number | undefined {
    if (typeof lastPage?.has_more === 'boolean') {
        if (!lastPage.has_more) return undefined

        const responsePage = Number(lastPage.page)
        if (Number.isInteger(responsePage) && responsePage > 0) return responsePage + 1
        return loadedPageCount + 1
    }

    return lastPage?.items?.length ? loadedPageCount + 1 : undefined
}
